var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 2.66667V6H3.05475M3.05475 6C3.49731 4.90542 4.29054 3.98861 5.3101 3.39324C6.32967 2.79788 7.51795 2.55761 8.68873 2.71009C9.85951 2.86258 10.9466 3.3992 11.7797 4.23585C12.6127 5.07251 13.1446 6.16191 13.2921 7.33333M3.05475 6H6.00008M13.3334 13.3333V10H12.9461M12.9461 10C12.5029 11.0939 11.7094 12.01 10.69 12.6049C9.67051 13.1997 8.48257 13.4397 7.31215 13.2872C6.14172 13.1348 5.05488 12.5986 4.22177 11.7625C3.38866 10.9264 2.85632 9.83763 2.70808 8.66667M12.9461 10H10.0001",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshOutline);
export default __webpack_public_path__ + "static/media/RefreshOutline.3eee37c54eebc8b25d9e0e0581412b8f.svg";
export { ForwardRef as ReactComponent };